import React, { useEffect, useState, useRef } from 'react';
import imgLoading from '@/assets/images/loading.svg';
import imgSky from '@/assets/images/scene/sky.png';
import imgGround from '@/assets/images/scene/ground.png';
import imgFront from '@/assets/images/scene/front.png';
import imgCompanyLogo from '@/assets/images/companyLogo.png';
import imgNextArrow from '@/assets/images/arrowNext.png';
import page1Slogan from '@/assets/images/page1Slogan.png';


// page2
import page2Slogan from '@/assets/images/page2Slogan.png';
import item2 from '@/assets/images/item2.png';
import item3 from '@/assets/images/item3.png';

// page3
import imgMy from '@/assets/images/index/btnMy.png';
import imgRule from '@/assets/images/rule.png';
import item4 from '@/assets/images/item4.png';
import imgBlock2 from '@/assets/images/index/block2.png';
import imgBlock3 from '@/assets/images/index/block3.png';
import imgClose from '@/assets/images/complete/close.png';

// page4
import imgBg from '@/assets/images/alert/bg.png';
import imglogin from '@/assets/images/alert/labelLogin.png';
import imgPaper from '@/assets/images/wish/paper.png';
import imgCorner from '@/assets/images/wish/corner.png';
import imgFlag from '@/assets/images/wish/flag.png';
import imgFlower from '@/assets/images/wish/paperFlower.png';
import imgFooter from '@/assets/images/wish/envelope.png';
import imgBtn from '@/assets/images/btn/btn.png';
import imgBgNoWish from '@/assets/images/noWish/bg.png';

import {useResLoading} from '@/hooks';
import Page3 from './page3';
import Page1 from './page1';
import Page2 from './page2';


import styles from './index.less';

const Page = () => {
  
  const res=[
    imgSky,
    imgGround,
    imgFront,
    imgCompanyLogo,
    imgNextArrow,
    page1Slogan,
  ]
  const resLoading = useResLoading({
    res,run:true,
    name:'首屏预加载'
  })
  const page2Loading = useResLoading({
    res:[page2Slogan,item2,item3],run:true,
    name:'page2预加载'
  })

  const page3Loading = useResLoading({
    res:[imgMy,imgRule,item4,imgBlock2,imgBlock3,imgClose],run:false,
    name:'page3预加载'
  })

  const page4Loading = useResLoading({
    res:[imgBg,
      imglogin,
      imgPaper,
      imgCorner,
      imgFlag,
      imgFlower,
      imgFooter,
      imgBtn,
      imgBgNoWish],run:false,
    name:'page4预加载'
  })

  const [curPage,setPage] = useState(0);

  const [leftGround,setLeftGround] = useState(0);
  const [leftFront,setLeftFront] = useState(0);
  const [spriteState,setSpriteState] = useState(0);
  const refSprite = useRef();
  const refCurPage = useRef();

  useEffect(()=>{
    refCurPage.current = curPage;
    if(refSprite.current){
      if(spriteState)return;
      setSpriteState(1);
      runSprite();
    }
  })
  

  const runSprite=()=>{
    var action = {
      duration:3,
      x:"random(-40, 40, 5)",
      y:"random(-30, 30, 5)",
      scale:"random(0.9,1.4,0.1)",
      backgroundColor:"random(['#e2f687', '#f4df6d', '#eee6b9'])",
    };
    switch(refCurPage.current){
      case 1:{
        action.x="random(-170, -100, 5)";
        action.y="random(60, 150, 5)";
      }break;
      case 2:{
        action.x="random(-80, 20, 5)";
        action.y="random(-260, -200, 5)";
      }break;
    }
    console.log(action);
    gsap.to(refSprite.current, {
      ...action,
      onComplete:()=>{
        runSprite();
      },
    });
  }

  const setPageX=(page)=>{
    var docEl = document.documentElement;
    let screenW = Math.max(window.innerWidth, docEl.clientWidth, docEl.offsetWidth);
    let maxWidth = document.querySelector('#ground').clientWidth
    let oneWidth = (maxWidth-screenW)/2;
    setLeftGround(-oneWidth*page);

    maxWidth = document.querySelector('#front').clientWidth
    oneWidth = (maxWidth-screenW)/2;
    setLeftFront(-oneWidth*page)
  }
  const onChangePage=()=>{
    setPage((v)=>{
      v= (v+1)%3;
      switch(v){
        case 1:{page3Loading.run();}break;
        case 2:{page4Loading.run();}break;
      }
      setPageX(v);
      return v;
    })
  }



  if(resLoading.loading>0){
    return (
      <section className={styles.loading}>
        <img src={imgLoading} />
      </section>
    )
  }
  


  return (
    <section className={styles.wrap}>
      <section className={styles.scene} data-page={curPage}>
        <img id="sky" src={imgSky} className={`${styles.sky} ${curPage==2?styles.anSky:''}`}/>
        <img id="ground" src={imgGround} className={styles.ground} style={{left:`${leftGround}px`}} />
        <img id="front" src={imgFront} className={styles.front} style={{left:`${leftFront}px`}} />
        
        <img src={imgCompanyLogo} className={styles.companyLogo} data-show={curPage!=2}/>

        <div ref={refSprite} className={styles.sprite} />


        <section className={styles.wrapNext} data-show={curPage!=2}>
          <img className={`${styles.arrow} ${styles.anArrow}`} src={imgNextArrow} onClick={onChangePage} />
        </section>
        <section className={styles.page}>
          <Page1 show={curPage==0} />
          <Page2 show={curPage==1} />
          <Page3 show={curPage==2} />
        </section>
      </section>
      

    </section>
  )
}

export default Page;